import React from "react";
import { Link } from "react-router-dom";
import companyLogo from "../assets/img/CenSyn_logo.png";

function Navbar() {
  return (
    <header className="bg-white shadow-sm fixed-top">
      <div className="d-flex align-items-center justify-content-between flex-wrap py-2 px-4 px-md-5 px-lg-7">
        <Link
          to="/"
          className="d-flex align-items-center"
          style={{ minWidth: "120px" }}
        >
          <img
            src={companyLogo}
            alt="Company Logo"
            style={{
              height: "50px",
              objectFit: "contain",
            }}
          />
        </Link>

        {/* Right: Navigation Links */}
        <div
          className="d-flex align-items-center"
          style={{
            gap: "1rem",
            flexWrap: "wrap",
          }}
        >
          {/* <Link
            to="/technology"
            className="text-dark fw-semibold text-decoration-none"
            style={{
              fontSize: "0.95rem",
              whiteSpace: "nowrap",
            }}
          >
            Technology
          </Link> */}

          <Link
            to="/login"
            className="btn btn-info text-white fw-semibold px-3 py-2"
            style={{
              fontSize: "0.9rem",
              whiteSpace: "nowrap",
            }}
          >
            Sign In
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
